import * as yup from 'yup';

export const createFormSchemas = (t) => {
  const formSchemaEmail = yup.object().shape({
    email: yup
      .string()
      .typeError(t('principal.messages.validation.email_required'))
      .required(t('principal.messages.validation.email_required'))
      .email(t('principal.messages.validation.invalid_email')),
  });

  const formSchemaTelefone = yup.object().shape({
    dddMovel: yup
      .string()
      .typeError(t('principal.messages.validation.ddd_required'))
      .required(t('principal.messages.validation.ddd_required')),
    foneMovel: yup
      .string()
      .typeError(t('principal.messages.validation.phone_required'))
      .required(t('principal.messages.validation.phone_required'))
      .test(
        'fone-movel-alteracao-br',
        t('cadastro.messages.validation.brazilian_mobile_format'),
        function (value) {
          if (!value) return true;
          // Valida como celular brasileiro se:
          // 1. Não tem DDI especificado (brasileiro)
          // 2. DDI é 55 (brasileiro ou estrangeiro residente no Brasil)
          if (!this.parent.ddiMovel || this.parent.ddiMovel === '55') {
            const digits = value.replace(/\D/g, '');
            return /^9\d{8}$/.test(digits);
          }
          // Se DDI é diferente de 55, permite qualquer formato
          return true;
        }
      ),
  });

  const formSchemaSenha = yup.object().shape({
    novaSenha: yup
      .string()
      .typeError(t('principal.messages.validation.password_required'))
      .required(t('principal.messages.validation.new_password_required'))
      .test(
        'no-slashes',
        t('cadastro.messages.validation.password_no_slashes'),
        (value) => {
          if (!value) return true;
          return !value.includes('/') && !value.includes('\\');
        },
      )
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,15}$/,
        t('principal.messages.validation.password_match'),
      ),
    confirmaSenha: yup
      .string()
      .typeError(t('principal.messages.validation.confirm_password_required'))
      .required(t('principal.messages.validation.confirm_password_required'))
      .oneOf(
        [yup.ref('novaSenha'), null],
        t('principal.messages.validation.passwords_must_match'),
      ),
  });

  const formSchemaAlteraDados = yup.object().shape({
    nome: yup
      .string()
      .typeError(t('principal.messages.validation.name_required'))
      .required(t('principal.messages.validation.name_required')),
    /*dataNascimento: yup
      .date()
      .typeError(t('principal.messages.validation.birth_date_required'))
      .required(t('principal.messages.validation.birth_date_required'))
      .max(
        new Date(),
        t('principal.messages.validation.birth_date_future'),
      )
      .test(
        'maiorIdade',
        t('principal.messages.validation.minimum_age'),
        function (value) {
          const dataNascimento = new Date(value);
          const diferenca = new Date() - dataNascimento;
          const idade = Math.floor(diferenca / (1000 * 60 * 60 * 24 * 365));
          return idade >= 18;
        },
      ),*/
  });

  const formSchemaAlteraDadosEstrangeiro = yup.object().shape({
    informarCpf: yup.boolean().notRequired(),
    maeDesconhecida: yup.boolean().notRequired(),
    nome: yup
      .string()
      .typeError(t('principal.messages.validation.name_required'))
      .required(t('principal.messages.validation.name_required')),
    nomeDaMae: yup.string().when(['informarCPF', 'maeDesconhecida'], {
      is: (informarCPF, maeDesconhecida) =>
        informarCPF === true && maeDesconhecida === false,
      then: yup
        .string()
        .typeError(t('principal.messages.validation.mothers_name_required'))
        .required(t('principal.messages.validation.mothers_name_required')),
      otherwise: yup.string().notRequired(),
    }),
    cpf: yup.string().when('informarCPF', {
      is: (informarCPF) => informarCPF === true,
      then: yup
        .string()
        .typeError(t('principal.messages.validation.cpf_required'))
        .required(t('principal.messages.validation.cpf_required')),
      otherwise: yup.string().notRequired(),
    }),
    dataNascimento: yup.date().when('informarCPF', {
      is: (informarCPF) => informarCPF === true,
      then: yup
        .date()
        .typeError(t('principal.messages.validation.birth_date_required'))
        .required(t('principal.messages.validation.birth_date_required'))
        .max(new Date(), t('principal.messages.validation.birth_date_future'))
        .test(
          'maiorIdade',
          t('principal.messages.validation.minimum_age'),
          function (value) {
            const dataNascimento = new Date(value);
            const diferenca = new Date() - dataNascimento;
            const idade = Math.floor(diferenca / (1000 * 60 * 60 * 24 * 365));
            return idade >= 18;
          },
        ),
      otherwise: yup.date().notRequired(),
    }),
  });

  const formSchemaAlteraDadosPJ = yup.object().shape({
    nome: yup
      .string()
      .typeError(t('principal.messages.validation.company_name_required'))
      .required(t('principal.messages.validation.company_name_required')),
    nomeFantasia: yup
      .string()
      .max(100, t('principal.messages.validation.trade_name_max_length')),
  });

  return {
    formSchemaEmail,
    formSchemaTelefone,
    formSchemaSenha,
    formSchemaAlteraDados,
    formSchemaAlteraDadosEstrangeiro,
    formSchemaAlteraDadosPJ,
  };
};

// Backward compatibility exports for direct imports
export const formSchemaEmail = null;
export const formSchemaTelefone = null;
export const formSchemaSenha = null;
export const formSchemaAlteraDados = null;
export const formSchemaAlteraDadosEstrangeiro = null;
export const formSchemaAlteraDadosPJ = null;
